import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

interface ColorPickerProps {
  value?: string;
  onChange: (value: string) => void;
}

const presetColors = [
  '#3b82f6', // blue
  '#10b981', // green
  '#8b5cf6', // purple
  '#f59e0b', // amber
  '#ef4444', // red
  '#06b6d4', // cyan
  '#ec4899', // pink
  '#84cc16', // lime
  '#f97316', // orange
  '#6366f1', // indigo
];

export const ColorPicker = ({ value, onChange }: ColorPickerProps) => {
  return (
    <div className="flex gap-2">
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" className="w-full justify-start">
            <div
              className="h-4 w-4 rounded mr-2 border"
              style={{ backgroundColor: value || '#3b82f6' }}
            />
            {value || '#3b82f6'}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-64">
          <div className="space-y-3">
            <div className="text-sm font-medium">Cores Pré-definidas</div>
            <div className="grid grid-cols-5 gap-2">
              {presetColors.map((color) => (
                <button
                  key={color}
                  className="h-8 w-8 rounded border-2 hover:scale-110 transition-transform"
                  style={{ 
                    backgroundColor: color,
                    borderColor: value === color ? '#000' : 'transparent'
                  }}
                  onClick={() => onChange(color)}
                />
              ))}
            </div>
            <div className="space-y-2">
              <div className="text-sm font-medium">Cor Customizada</div>
              <Input
                type="color"
                value={value || '#3b82f6'}
                onChange={(e) => onChange(e.target.value)}
                className="h-10"
              />
            </div>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
